import * as queryString from 'query-string';
import { FilterActions, FilterActionTypes, SearchActionTypes } from '../actions/ActionTypes';
import { FilterTypes } from '../models/FilterTypes';
import { initialState, FilterState, FilterQuery, FilterAllOption } from '../state/FilterState';

export const filterReducer = (previousState: FilterState = initialState, action: FilterActions): FilterState => {
  switch (action.type) {
    case SearchActionTypes.CHANGE_CONTENT_BY_URL_PATH: {
      const filters: FilterQuery = Object.keys(FilterTypes).reduce((obj, type) => {
        const id = queryString.parse(action.filters)[type] ? queryString.parse(action.filters)[type] : FilterAllOption;
        // we navigate by url after the change filter action and we do not store the value in the url
        if (previousState.query[type as FilterTypes].id !== id) {
          return { ...obj, [type]: { id: id, value: '' } };
        } else {
          return { ...obj };
        }
      }, {} as FilterQuery);
      return {
        ...previousState,
        query: { ...previousState.query, ...filters },
      };
    }
    case FilterActionTypes.UPDATE_FILTER: {
      const query = previousState.query;
      query[action.filterType] = { id: action.id, value: action.value };
      return {
        ...previousState,
        isLoadingFilterContent: true,
        query: { ...query },
      };
    }
    case SearchActionTypes.SEARCH_SUCCESS:
      return {
        ...previousState,
        isLoadingFilterContent: false,
      };
    case SearchActionTypes.SEARCH_FAILED:
      return {
        ...previousState,
        isLoadingFilterContent: false,
      };
    default:
      return previousState;
  }
};
